<template>
  <div class="hidden-print-only">
    <div class="title-bar" :class="{'white-background-transparent': hgInspectionPage }">
      <div class="logo-container" :class="{'white-background': hgInspectionPage }" >
        <img
          v-if="hgLogo"
          class="logo"
          :src="hgLogo"
          alt="Inspector Company Logo" />
      </div>
      <div class="inner-header">
          <div class="address">
            {{hgAddress}}
            <div class="location">{{hgLocation}}</div>
          </div>
        <div class="actions">
            <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hgAddress: {
      required: true,
      type: String,
    },
    hgLocation: {
      required: true,
      type: String,
    },
    hgLogo: {
      required: false,
      type: String,
    },
    hgInspectionPage: {
      required: false,
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

.title-bar {
  border-bottom: solid 3px $theme-color-primary;
  color: $theme-color-black;
  display: flex;
  font-family: $typography-font-secondary;
}

.address {
  align-items: flex-start;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  font-size: 2.5rem;
  font-weight: $typography-weight-bold;
  padding-left: 20px;
  padding-right: 10px;
}

.location {
  font-size: 1.5rem;
  font-weight: $typography-weight-bold;
  padding-top: 10px;
}

.inner-header {
  display: flex;
  flex-grow: 2;
  margin: 55px 0;
}

.white-background {
  background-color: $theme-color-white;

  &-transparent {
    background-color: rgba($theme-color-white, 0.7);
    border-bottom: none;
  }

  &.logo-container {
    margin-left: 0;
  }
}

.actions {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  margin-right: 30px;
}

.logo {
  height: auto;
  max-height: 100%;
  max-width: 100%;
  width: auto;

  &-container {
    align-items: center;
    display: flex;
    justify-content: center;
    margin-left: 20px;
    max-height: 160px;
    max-width: 200px;
  }
}

@media all and (max-width: 1250px) {
  .address {
    font-size: 3.2vw;
  }

  .location {
      font-size: 2.5vw;
    }

  .logo-container {
    max-height: 150px;
    max-width: 150px;
  }
}

@media all and (max-width: 655px) {
  .title-bar {
    align-items: center;
    background: none;
    color: rgba(0, 0, 0, 0.75);
    flex-direction: column;
    padding-bottom: 0;
  }

  .address,
  .logo {
    flex: 1 1 auto;
  }

  .logo-container {
    margin-left: 0;
  }

  .address {
    align-items: center;
    font-size: 5.5vw;
    padding: 30px 16px 0;
  }

  .address,
  .location {
    font-size: 1.214rem;
    font-weight: $typography-weight-bold;
  }

  .inner-header {
    align-items: center;
    flex-direction: column;
    margin-top: 0;
  }

  .actions {
    align-items: center;
    margin-right: 0;
    margin-top: 20px;
  }

  .logo {
    max-height: 100px
  }
}
</style>
